module.exports = __webpack_public_path__ + "static/media/angular.368685db.jpg";